import React, { useContext } from 'react'
import { ApplicationAreaScreen } from '../Constant'
import { FileContext } from '../Context'
import FilesOverview from './FilesOverview'
import InformationForm from './InformationForm'

const MainContainer: React.FC = (): React.ReactElement => {
  const { screen } = useContext(FileContext)
  switch (screen) {
    case ApplicationAreaScreen.FILE:
      return <FilesOverview />
    case ApplicationAreaScreen.INFORMATION_FORM:
      return <InformationForm />
    default:
      return <FilesOverview />
  }
}

export default MainContainer
